

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class SubscribeGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        return this.verifySubscribed();
    }

    verifySubscribed(): boolean {
        const isSubscribed = this.authService.isSubscribed();
        if (!isSubscribed) {
            this.router.navigate(['/payment']);
            return false;
        }
        return true;
    }
}
